import React from 'react';
import ClinicGrowth from '../components/ClinicGrowth';

const ClinicGrowthPage = () => {
  return (
    <>
      <ClinicGrowth />
    </>
  );
};

export default ClinicGrowthPage;